import { Helmet } from "react-helmet";
import AboutLayout from "../section/about/about-layout";

const AboutPage = () => {
    <Helmet>
        <title>About Digital Tourism | Sri Lanka’s Leading Travel-Tech Innovator</title>
        <meta name="description" content="Learn about Digital Tourism, a pioneering travel-tech company in Sri Lanka dedicated to transforming tourism through digital platforms, smart travel tools, and technology-driven experiences." />
        <meta name="keywords" content="about Digital Tourism, travel tech company Sri Lanka, tourism innovation Sri Lanka, digital travel solutions" />
    </Helmet>

    return (
        <>
            <AboutLayout />
        </>
    );
}

export default AboutPage;